import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Clock, Phone } from "lucide-react";

const Footer = () => (
  <footer className="bg-forestdeep text-cream relative grain" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 md:px-10 pt-16 pb-8">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo.png" alt="Chai Times logo" className="w-14 h-14 rounded-full object-contain" />
            <span className="font-lobster text-4xl">Chai <span className="text-gold">Times</span></span>
          </div>
          <p className="text-cream/60 max-w-sm leading-relaxed">
            More than chai, it's an experience. A moment of warmth, a shared conversation, a comforting ritual — one kulhad at a time.
          </p>
          <a
            href="https://www.instagram.com/chaitimes.in"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center gap-2 mt-6 font-mono text-xs uppercase tracking-[0.2em] text-gold hover:text-cream transition-colors"
          >
            <Instagram size={16} /> @chaitimes.in
          </a>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold mb-5">Explore</p>
          <ul className="space-y-3 text-cream/70">
            {[["/", "Home"], ["/about", "Our Story"], ["/menu", "Menu"], ["/locations", "Outlets"], ["/franchise", "Franchise"], ["/journal", "Journal"]].map(([to, label]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`} className="hover:text-terracotta transition-colors">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold mb-5">Head Office</p>
          <div className="space-y-4 text-cream/70 text-sm">
            <p className="font-bold text-cream">Secander Food &amp; Beverages LLP</p>
            <p className="flex gap-3"><MapPin size={16} className="shrink-0 mt-0.5 text-terracotta" /> No. 415, Ground Floor, 4th B Cross, HRBR Layout, Kalyan Nagar, Bengaluru - 560043</p>
            <p className="flex gap-3 items-center"><Clock size={16} className="text-terracotta" /> 10 AM – 6 PM, Monday to Friday</p>
            <a href="mailto:info@chaitimes.in" data-testid="footer-email" className="flex gap-3 items-center hover:text-terracotta transition-colors">
              <Mail size={16} className="text-terracotta" /> info@chaitimes.in
            </a>
            <a href="tel:+917019368165" data-testid="footer-phone" className="flex gap-3 items-center hover:text-terracotta transition-colors">
              <Phone size={16} className="text-terracotta" /> +91-70193 68165
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-cream/10 mt-12 pt-6 flex flex-col md:flex-row justify-between gap-3 font-mono text-[11px] uppercase tracking-[0.2em] text-cream/40">
        <p>© 2021 Chai Times. Brewed with patience in Bengaluru.</p>
        <p>Chai tastes best with Kulhad</p>
      </div>
    </div>
  </footer>
);

export default Footer;
